import { render, staticRenderFns } from "./ExAvatar.vue?vue&type=template&id=bf4a3480&scoped=true"
import script from "./ExAvatar.vue?vue&type=script&lang=js"
export * from "./ExAvatar.vue?vue&type=script&lang=js"
import style0 from "./ExAvatar.vue?vue&type=style&index=0&id=bf4a3480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a3480",
  null
  
)

export default component.exports